import CompanyBranchesCrud from 'components/crudCompanyBranches/crudCompanyBranchesData'
import SingleTabCrudContent from 'components/genericCrud/SingleTabCrudContent'
import { CRUD_COMPANY_BRANCHES_DATA } from 'utils/RoutePath'

export const companyBranchesCrudConfig = {
	id: 'companyBranchesCrud',
	key: 'cod_sucursal',
	descrip: 'descrip',
	searchMethod: 'get',
	category: 'A',
	translation: 'branches',
	dataUrl: CRUD_COMPANY_BRANCHES_DATA,
	urlApi: 'abm_Emp_sucursales',
	component: SingleTabCrudContent,
	tabsList: [
		{
			key: 'basic', // Llave de la tab, puede ser basic, atrib, comission.
			title: 'CRUDS.general_use.basic_tab',
			tabComponent: CompanyBranchesCrud // Componente de la Tab en React
		}
	],
	tabsGroupsAlta: ['form_alta'] // Grupos a utilizar para mostrar los campos del principal y cada tab en orden
}
